"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSingleParentheses = exports.captionControl = exports.makeDoubleIndentBlockWithCaptureRule = exports.makeIndentBlockWithCaptureRule = exports.$indentBlock = exports.$blankLine = exports.$optBNK_DEDENT = exports.$DEDENT = exports.$optBNK_INDENT = exports.$INDENT = void 0;
const controls_1 = require("../../node/el/controls");
const line_1 = require("../../node/cst/line");
const error_1 = require("../cst/error");
const factory_1 = __importDefault(require("./factory"));
const virtualLine_1 = require("./virtualLine");
exports.$INDENT = factory_1.default
    .withName("INDENT")
    .oneMatch(({ item }) => item.type === virtualLine_1.VirtualOnlyLineType.IND ? item : null);
exports.$optBNK_INDENT = factory_1.default
    .withName("optBNK_INDENT")
    .sequence(s => s
    .and(r => r.zeroOrMore(() => exports.$blankLine), "optBNK")
    .and(r => r.oneMatch(({ item }) => item.type === virtualLine_1.VirtualOnlyLineType.IND ? item : null), "INDENT")
    .action(({ optBNK, INDENT }) => [...optBNK, INDENT]));
exports.$DEDENT = factory_1.default
    .withName("DEDENT")
    .oneMatch(({ item }) => item.type === virtualLine_1.VirtualOnlyLineType.DED ? item : null);
exports.$optBNK_DEDENT = factory_1.default
    .withName("optBNK_DEDENT")
    .sequence(s => s
    .and(r => r.zeroOrMore(() => exports.$blankLine), "optBNK")
    .and(r => r.oneMatch(({ item }) => item.type === virtualLine_1.VirtualOnlyLineType.DED ? item : null), "DEDENT")
    .action(({ optBNK, DEDENT }) => [...optBNK, DEDENT]));
exports.$blankLine = factory_1.default
    .withName("blankLine")
    .oneMatch(({ item }) => item.type === line_1.LineType.BNK ? item : null);
exports.$indentBlock = factory_1.default
    .withName("indentBlock")
    .asSlice(r => r
    .sequence(s => s
    .and(() => exports.$INDENT)
    .and(r => r
    .zeroOrMore(r => r
    .choice(c => c
    .or(() => exports.$blankLine)
    .orSequence(s => s
    .and(r => r.nextIsNot(() => exports.$INDENT))
    .and(r => r.nextIsNot(() => exports.$DEDENT))
    .and(r => r.anyOne()))
    .or(() => exports.$indentBlock))))
    .and(() => exports.$DEDENT)));
const makeIndentBlockWithCaptureRule = (ruleName, ruleRepeatedOneOrMore) => factory_1.default
    .withName(ruleName)
    .sequence(s => s
    .andOmit(() => exports.$optBNK_INDENT)
    .andOmit(r => r.zeroOrMore(() => exports.$blankLine))
    .and(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(r => r
    .orSequence(r => r
    .and(() => ruleRepeatedOneOrMore, "success")
    .action(({ success }) => ({ success, errorLines: [] })))
    .orSequence(s => s
    .and(r => r
    .asSlice(r => r
    .choice(c => c
    .or(() => exports.$indentBlock)
    .orSequence(s => s
    .andOmit(r => r.nextIsNot(() => exports.$optBNK_DEDENT))
    .and(r => r.anyOne())))), "captured")
    .action(({ captured }) => ({ success: null, errorLines: captured })))))
    .andOmit(r => r.zeroOrMore(() => exports.$blankLine)))), "childrenAndErrors")
    .andOmit(() => exports.$optBNK_DEDENT)
    .action(({ childrenAndErrors }) => {
    // const err = childrenAndErrors.filter(c => !c.success);
    // if (err.length > 5) {
    //     console.log(JSON.stringify(err.slice(0, 5), null, 2));
    // }
    for (let i = 0; i < childrenAndErrors.length; i += 1) {
        while (!childrenAndErrors[i].success && i + 1 < childrenAndErrors.length && !childrenAndErrors[i + 1].success) {
            childrenAndErrors[i].errorLines.push(...childrenAndErrors.splice(i + 1, 1)[0].errorLines);
        }
    }
    const children = [];
    const errors = [];
    for (const { success, errorLines } of childrenAndErrors) {
        if (success) {
            children.push(success);
        }
        if (errorLines.length > 0) {
            errors.push(new error_1.ErrorMessage(`${ruleName}: この部分をパースできませんでした。`, [
                errorLines[0].virtualRange[0],
                errorLines.slice(-1)[0].virtualRange[1],
            ]));
        }
    }
    return {
        value: children,
        errors,
    };
}));
exports.makeIndentBlockWithCaptureRule = makeIndentBlockWithCaptureRule;
const makeDoubleIndentBlockWithCaptureRule = (ruleName, ruleRepeatedOneOrMore) => factory_1.default
    .withName(ruleName)
    .sequence(s => s
    .andOmit(() => exports.$optBNK_INDENT)
    .andOmit(() => exports.$optBNK_INDENT)
    .andOmit(r => r.zeroOrMore(() => exports.$blankLine))
    .and(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(r => r
    .orSequence(r => r
    .and(() => ruleRepeatedOneOrMore, "success")
    .action(({ success }) => ({ success, errorLines: [] })))
    .orSequence(s => s
    .and(r => r
    .asSlice(r => r
    .choice(c => c
    .or(() => exports.$indentBlock)
    .orSequence(s => s
    .andOmit(r => r.nextIsNot(() => exports.$optBNK_DEDENT))
    .and(r => r.anyOne())))), "captured")
    .action(({ captured }) => ({ success: null, errorLines: captured })))))
    .andOmit(r => r.zeroOrMore(() => exports.$blankLine)))), "childrenAndErrors1")
    .andOmit(() => exports.$optBNK_DEDENT)
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(r => r
    .asSlice(r => r
    .choice(c => c
    .or(() => exports.$indentBlock)
    .orSequence(s => s
    .andOmit(r => r.nextIsNot(() => exports.$optBNK_DEDENT))
    .and(r => r.anyOne())))), "captured")
    .andOmit(r => r.zeroOrMore(() => exports.$blankLine))
    .action(({ captured }) => ({ success: null, errorLines: captured })))), "errors2")
    .andOmit(() => exports.$optBNK_DEDENT)
    .action(({ childrenAndErrors1, errors2 }) => {
    const childrenAndErrors = [...childrenAndErrors1, ...errors2];
    for (let i = 0; i < childrenAndErrors.length; i += 1) {
        while (!childrenAndErrors[i].success && i + 1 < childrenAndErrors.length && !childrenAndErrors[i + 1].success) {
            childrenAndErrors[i].errorLines.push(...childrenAndErrors.splice(i + 1, 1)[0].errorLines);
        }
    }
    const children = [];
    const errors = [];
    for (const { success, errorLines } of childrenAndErrors) {
        if (success) {
            children.push(success);
        }
        if (errorLines.length > 0) {
            errors.push(new error_1.ErrorMessage(`${ruleName}: この部分をパースできませんでした。`, [
                errorLines[0].virtualRange[0],
                errorLines.slice(-1)[0].virtualRange[1],
            ]));
        }
    }
    return {
        value: children,
        errors,
    };
}));
exports.makeDoubleIndentBlockWithCaptureRule = makeDoubleIndentBlockWithCaptureRule;
exports.captionControl = ":caption:";
const isSingleParentheses = (line) => {
    let columns = [];
    if (Array.isArray(line)) {
        columns = line;
    }
    else if ((0, virtualLine_1.isVirtualLine)(line) && "line" in line && line.line.type === line_1.LineType.OTH) {
        columns = line.line.sentencesArray;
    }
    else if (!(0, virtualLine_1.isVirtualLine)(line) && line.type === line_1.LineType.OTH) {
        columns = line.sentencesArray;
    }
    return (columns.length === 1
        && columns[0].sentences.length === 1
        && columns[0].sentences[0].children.length === 1
        && columns[0].sentences[0].children[0] instanceof controls_1.__Parentheses
        && columns[0].sentences[0].children[0].attr.type === "round"
    // && typeof columns[0].sentences[0].children[0] !== "string"
    // && columns[0].sentences[0].children[0].tag === "__Parentheses"
    ) ? columns[0].sentences[0].children[0] : null;
};
exports.isSingleParentheses = isSingleParentheses;
//# sourceMappingURL=util.js.map